import { useCallback } from 'react';
import { SET_BILLING_ADDRESS } from '../queries/cart';
import useCartMutation from './useCartMutation';

const useSetBillingAddress = () => {
  const [mutation, { loading, error }] = useCartMutation(SET_BILLING_ADDRESS);

  const setBillingAddress = useCallback(
    ({ address, customerAddressId }) => {
      return mutation({
        variables: {
          input: {
            billing_address: {
              address,
              customer_address_id: customerAddressId,
            },
          },
        },
      });
    },
    [mutation],
  );

  return {
    setBillingAddress,
    loading,
    error,
  };
};

export default useSetBillingAddress;
